import { render } from "./gbyunying.vue?vue&type=template&id=4073ca4a&scoped=true"
import script from "./gbyunying.vue?vue&type=script&lang=js"
export * from "./gbyunying.vue?vue&type=script&lang=js"

import "./gbyunying.vue?vue&type=style&index=0&id=4073ca4a&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-4073ca4a"

export default script